module.exports = __webpack_public_path__ + "static/media/redux.4912f6d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/frontend/redux.png
// module id = 1534
// module chunks = 0